import React from 'react';
import { prettifyNumbers } from 'lib/dateUtilities';

const Action = ({
    count,
    onClick,
    disabled = false,
    ariaLabel,
    tooltipPrefix = "Total: ",
    buttonClassName = "",
    iconClassName = "",
    countClassName = ""
}) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center ${buttonClassName}`}
            disabled={disabled}
            aria-label={ariaLabel}
        >
            <i className={iconClassName}></i>
            <span className={`pl-2 ${countClassName}`} title={`${tooltipPrefix}${count.toLocaleString()}`}>
                {prettifyNumbers(count)}
            </span>
        </button>
    );
};

export default Action;
